export const portalNode = document.getElementById('finance-free-report-portal');

export const stepList = [
  'kpi',
  'metric_name',
  'correlation_r',
  'industry_benchmark',
  'report_generation',
];

export const titlesByProcess = {
  processing: {
    kpi: 'Scanning public filings...',
    metric_name: 'Pulling mobile performance data...',
    correlation_r: 'Testing data correlations...',
    industry_benchmark: 'Benchmarking against industry...',
    report_generation: 'Generating report...',
  },
  processed: {
    kpi: 'Gathered company KPIs',
    metric_name: 'Pulled mobile performance data',
    correlation_r: 'Found data correlation!',
    industry_benchmark: 'Benchmarked against industry',
    report_generation: 'Report generated',
  },
};

export const stepsOptions = [
  { value: 'kpi', text: 'Scann public filings' },
  { value: 'metric_name', text: 'Pull mobile performance data' },
  { value: 'correlation_r', text: 'Test data correlations' },
  { value: 'industry_benchmark', text: 'Benchmark against industry' },
  { value: 'report_generation', text: 'Generate report' },
];
